<template>
  <b-tab
    id="EFECTY"
    data-test="EFECTY"
    title-link-class="tab-nav-icon EFECTY"
    @click="$emit('click')"
  >
    <template v-slot:title>
      <font-awesome-icon icon="credit-card" class="icon" />
      EFECTY
    </template>
  </b-tab>
</template>

<script>
export default {
  name: 'Efecty'
}
</script>
